// Number animation
document.addEventListener('DOMContentLoaded', function () {

  const counters = document.querySelectorAll('.number-animate');

  const observer = new IntersectionObserver((entries, observer) => {

    entries.forEach(entry => {

      if (!entry.isIntersecting) return;

      const element = entry.target;
      const originalText = element.textContent.trim();

      // Find the numeric part of the text
      const match = originalText.match(/-?[\d,.]+/);

      if (!match) {
        observer.unobserve(element);
        return;
      }

      const numberText = match[0];
      const target = parseFloat(numberText.replace(/,/g, ''));

      // Everything before and after the actual number stays untouched
      const prefix = originalText.substring(0, match.index);
      const suffix = originalText.substring(
        match.index + numberText.length
      );

      // Detect decimal places
      const decimalPart = numberText.replace(/,/g, '').split('.')[1];
      const decimals = decimalPart ? decimalPart.length : 0;

      const duration = 1500;
      const startTime = performance.now();

      function animate(currentTime) {

        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Smooth ease-out animation
        const easedProgress = 1 - Math.pow(1 - progress, 3);

        const currentValue = target * easedProgress;

        const formattedNumber = currentValue.toLocaleString('en-US', {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        });

        element.textContent =
          prefix +
          formattedNumber +
          suffix;

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          // Ensure the final value exactly matches original text
          element.textContent = originalText;
        }
      }

      requestAnimationFrame(animate);

      // Animate only once
      observer.unobserve(element);

    });

  }, {
    threshold: 0.3
  });

  counters.forEach(counter => observer.observe(counter));

});


// Section Animation
(function () {

  function initScrollAnimations(scope = document) {

    const elements = scope.querySelectorAll(
      '.animate-reveal:not([data-animation-initialized])'
    );

    if (!elements.length) return;


    /* Respect accessibility settings */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {

      elements.forEach(element => {
        element.classList.add('is-visible');
        element.dataset.animationInitialized = 'true';
      });

      return;
    }


    const observer = new IntersectionObserver((entries, observer) => {

      entries.forEach(entry => {

        if (!entry.isIntersecting) return;

        const element = entry.target;

        const delay = parseInt(
          element.dataset.delay || 0,
          10
        );

        setTimeout(() => {
          element.classList.add('is-visible');
        }, delay);

        observer.unobserve(element);

      });

    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -8% 0px'
    });


    elements.forEach(element => {

      element.dataset.animationInitialized = 'true';

      /*
       Add initial hidden state through JS.
       This prevents content disappearing if JS fails.
      */
      element.classList.add('is-animation-ready');

      observer.observe(element);

    });

  }


  /* Initial load */
  initScrollAnimations();


  /*
   Shopify Theme Editor support.
   Useful even though there are no animation schema controls.
  */
  document.addEventListener('shopify:section:load', function(event) {
    initScrollAnimations(event.target);
  });

})();




document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.main-progress-bar-blog').forEach(function (bar) {

    if (bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';

    const fill = bar.querySelector('.cs__fill');
    const circle = bar.querySelector('.cs__circle-progress');
    const count = bar.querySelector('[data-count]');

    if (!fill && !circle) return;

    const progressElement = fill || circle;

    const targetWidth = parseFloat(progressElement.dataset.width) || 0;

    let targetCount = 0;
    let startText = '';
    let endText = '';
    let decimals = 0;

    if (count) {
      const finalText = count.dataset.count;
      const numberMatch = finalText.match(/-?\d+(\.\d+)?/);

      if (numberMatch) {
        targetCount = parseFloat(numberMatch[0]);
        decimals = (numberMatch[0].split('.')[1] || '').length;

        startText = finalText.slice(0, numberMatch.index);
        endText = finalText.slice(numberMatch.index + numberMatch[0].length);

        count.textContent = startText + (0).toFixed(decimals) + endText;
      }
    }

    if (fill) {
      fill.style.width = '0%';
      fill.style.transition = 'none';
    }

    if (circle) {
      circle.style.setProperty('--progress', '0%');
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {

        if (fill) {
          fill.style.transition = 'width 1600ms ease';
          fill.style.width = targetWidth + '%';
        }

        const start = performance.now();
        const duration = 1600;

        function animate(now) {

          const progress = Math.min((now - start) / duration, 1);

          if (circle) {
            circle.style.setProperty(
              '--progress',
              (targetWidth * progress) + '%'
            );
          }

          if (count && count.dataset.count.match(/-?\d+(\.\d+)?/)) {
            const value = targetCount * progress;

            count.textContent =
              startText + value.toFixed(decimals) + endText;
          }

          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        }

        requestAnimationFrame(animate);

      });
    });

  });

});


(function(){
  var boxes=[].slice.call(document.querySelectorAll('.check input'));
  var score=document.getElementById('score'),meter=document.getElementById('meter');
  var KEY='nv-pdp-checklist';
  try{var saved=JSON.parse(localStorage.getItem(KEY)||'[]');boxes.forEach(function(b){b.checked=saved.indexOf(b.id)>-1})}catch(e){}
  function update(){
    var n=boxes.filter(function(b){return b.checked}).length;
    score.textContent=n+' of '+boxes.length;
    meter.style.width=(n/boxes.length*100)+'%';
    try{localStorage.setItem(KEY,JSON.stringify(boxes.filter(function(b){return b.checked}).map(function(b){return b.id})))}catch(e){}
  }
  boxes.forEach(function(b){b.addEventListener('change',update)});
  update();
})();